import i18n from "@/plugins/vue-i18n";

const ForgotPassword = () =>
  import(/* webpackChunkName: "auth" */ "@/views/auth/forgot-password/ForgotPasswordPage.vue");

const login = [
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      title: i18n.t("title.passwordRecovery"),
    },
  },
];

export default login;
